import { topics } from "@/mocks/leakData";

export default function TopicCollection() {
  const [feature, ...grid] = topics;
  return (
    <section id="special" className="relative overflow-hidden bg-background-100">
      <div className="bg-paper pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.28em] text-primary-600">
              <i className="ri-stack-line" />
              Special
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              专题合集 · 深挖一处
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-secondary-600">
              围绕单一线索持续深挖，按题材聚合的完整调查档案合集。
            </p>
          </div>
        </div>

        {/* 首专题：纵长横幅 */}
        <a
          href="#special"
          className="group relative mb-5 block overflow-hidden rounded-xl"
        >
          <img
            src={feature.cover}
            alt={feature.title}
            className="h-60 w-full object-cover object-top transition duration-500 group-hover:scale-105 md:h-72"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 flex flex-col justify-end p-6 md:flex-row md:items-end md:justify-between md:p-8">
            <div className="max-w-2xl">
              <h3 className="font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/80">{feature.lead}</p>
            </div>
            <div className="mt-4 flex shrink-0 items-center gap-3 md:mt-0">
              <span className="rounded-full bg-background-50/15 px-3 py-1.5 text-xs text-background-50 backdrop-blur">
                {feature.count} 篇连载
              </span>
              <span className="rounded-full bg-primary-600 px-3 py-1.5 text-xs font-semibold text-background-50">
                {feature.read} 阅读
              </span>
            </div>
          </div>
        </a>

        {/* 其余专题 */}
        <div className="grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
          {grid.map((t) => (
            <a
              key={t.title}
              href="#special"
              className="group relative overflow-hidden rounded-xl"
            >
              <img
                src={t.cover}
                alt={t.title}
                className="aspect-[3/4] w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <h4 className="font-heading text-base font-bold leading-snug text-background-50 md:text-lg">
                  {t.title}
                </h4>
                <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-background-100/75">
                  {t.lead}
                </p>
                <div className="mt-3 flex items-center gap-2 text-[11px] text-background-100/80">
                  <span className="rounded-full bg-background-50/15 px-2 py-0.5">{t.count} 篇</span>
                  <span className="rounded-full bg-background-50/15 px-2 py-0.5">{t.read}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}